/* history.tsx generated by @compiled/babel-plugin v0.17.1 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React from "react";
import { InfoPanel } from "../components/info-panel";
import { Heading } from "../components/heading";
import { List } from "../components/list";
import JSONDiff from "../components/json-diff";
import { SplitView, SplitViewCol } from "../components/split-view";
import { Highlighter } from "../components/highlighter";
import theme from "../theme";
import { atom, useAtom, useAtomValue } from "jotai";
import { historyAtom, historyDiffsAtom, historyRolledBackToAtom } from "../state/history";
var _3 = "._129lrdoj+._129lrdoj{padding-top:9px}";
var _2 = "._vchhusvi{box-sizing:border-box}";
var _ = "._1ul9mgvx{min-width:180px}";
var Section = function Section(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2, _3]), /*#__PURE__*/React.createElement("div", {
    className: ax(["_1ul9mgvx _vchhusvi _129lrdoj"])
  }, children));
};
function pad(num) {
  return ("00" + num).slice(-2);
}
function pad3(num) {
  return ("000" + num).slice(-3);
}
var formatTimestamp = function formatTimestamp(timestamp) {
  var date = new Date(timestamp);
  return [pad(date.getHours()), pad(date.getMinutes()), pad(date.getSeconds()), pad3(date.getMilliseconds())].join(":");
};
export function SelectionContentSection(props) {
  if (!props.selectionContent) return null;
  var content = Array.isArray(props.selectionContent) ? props.selectionContent.join("\n") : props.selectionContent;
  return /*#__PURE__*/React.createElement(Section, null, /*#__PURE__*/React.createElement(Heading, null, "Selection Content"), /*#__PURE__*/React.createElement(Highlighter, null, content));
}
export function DocDiffSection(props) {
  if (!props.diff) return null;
  return /*#__PURE__*/React.createElement(Section, null, /*#__PURE__*/React.createElement(Heading, null, "Doc diff"), /*#__PURE__*/React.createElement(JSONDiff, {
    delta: props.diff
  }));
}
export function SelectionSection(props) {
  if (!props.selection) return null;
  return /*#__PURE__*/React.createElement(Section, null, /*#__PURE__*/React.createElement(Heading, null, "Selection diff"), /*#__PURE__*/React.createElement(JSONDiff, {
    delta: props.selection
  }));
}
var selectedHistoryItemAtom = atom(0);
export default function HistoryView(_ref2) {
  var _history$selectedHist;
  var rollbackHistory = _ref2.rollbackHistory;
  var _useAtom = useAtom(selectedHistoryItemAtom),
    _useAtom2 = _slicedToArray(_useAtom, 2),
    selectedHistoryItem = _useAtom2[0],
    setSelectedHistoryItem = _useAtom2[1];
  var historyRolledBackTo = useAtomValue(historyRolledBackToAtom);
  var history = useAtomValue(historyAtom);
  var historyDiffs = useAtomValue(historyDiffsAtom);
  var prevItem = history[selectedHistoryItem + 1];
  var selectedItem = (_history$selectedHist = history[selectedHistoryItem]) !== null && _history$selectedHist !== void 0 ? _history$selectedHist : history[0];
  var selectedDiff = historyDiffs[selectedItem.id];
  var historyRolledBackToItem = historyRolledBackTo !== null ? history[historyRolledBackTo] : null;
  var historyList = history.reduce(function (h, item, index) {
    var _historyDiffs$item$id;
    var prev = h[h.length - 1];
    item.index = index;
    if (!((_historyDiffs$item$id = historyDiffs[item.id]) !== null && _historyDiffs$item$id !== void 0 && _historyDiffs$item$id.diff)) {
      if (!prev || !Array.isArray(prev)) {
        h.push([item]);
      } else {
        prev.push(item);
      }
    } else {
      h.push(item);
    }
    return h;
  }, []).reduce(function (h, item) {
    if (Array.isArray(item) && item.length === 1) {
      h.push(item[0]);
    } else {
      h.push(item);
    }
    return h;
  }, []);
  var isSelected = function isSelected(item) {
    if (Array.isArray(item)) return false;
    return item.timestamp === selectedItem.timestamp;
  };
  var isPrevious = function isPrevious(item) {
    if (Array.isArray(item)) return false;
    return prevItem && item.timestamp === prevItem.timestamp;
  };
  var isDimmed = function isDimmed(item) {
    if (Array.isArray(item)) return false;
    return historyRolledBackToItem ? item.timestamp > historyRolledBackToItem.timestamp : false;
  };
  return /*#__PURE__*/React.createElement(SplitView, {
    testId: "__prosemirror_devtools_tabs_history__"
  }, /*#__PURE__*/React.createElement(SplitViewCol, {
    noPaddings: true,
    minWidth: 190
  }, /*#__PURE__*/React.createElement(List, {
    items: historyList,
    getKey: function getKey(item) {
      if (Array.isArray(item)) {
        return "" + item[0].timestamp;
      }
      return "" + item.timestamp;
    },
    title: function title(item) {
      if (Array.isArray(item)) {
        return formatTimestamp(item[0].timestamp);
      }
      return formatTimestamp(item.timestamp);
    },
    groupTitle: function groupTitle(item) {
      if (Array.isArray(item)) {
        return formatTimestamp(item[0].timestamp) + " [".concat(item.length, "]");
      }
      return formatTimestamp(item.timestamp);
    },
    isSelected: isSelected,
    isPrevious: isPrevious,
    isDimmed: isDimmed,
    customItemBackground: function customItemBackground(props) {
      return props.isSelected ? theme.main40 : props.isPrevious ? theme.main20 : "transparent";
    },
    onListItemClick: function onListItemClick(item) {
      if (Array.isArray(item)) return;
      setSelectedHistoryItem(item.index);
    },
    onListItemDoubleClick: function onListItemDoubleClick(item) {
      if (Array.isArray(item)) return;
      rollbackHistory(item, item.index);
    }
  })), /*#__PURE__*/React.createElement(SplitViewCol, {
    grow: true,
    sep: true
  }, /*#__PURE__*/React.createElement(DocDiffSection, {
    diff: selectedDiff
  }), /*#__PURE__*/React.createElement(SelectionSection, {
    selection: selectedItem.selection
  }), /*#__PURE__*/React.createElement(SelectionContentSection, {
    selectionContent: selectedItem.selectionContent
  }), !selectedDiff && !selectedItem.selectionContent && /*#__PURE__*/React.createElement(InfoPanel, null, "Docs are equal.")));
}